import { Bars } from 'react-loader-spinner';
import { useSelector } from 'react-redux';
import { toast } from '@insight-health-ai/roseate/components';
import { Button } from '../baseComponents';
import {
  AmbientloadIcon,
  BackIconMobile,
  CopiesIcon,
  DictateMic,
  DictateStopIcon,
  ExpandIcon,
  PinIcon,
  RegenIcon,
  ResumeIcon,
} from 'src/icons';
import { PastEncounterTopBar } from './PastEncounter.Topnavbar';
import { Resizable } from 're-resizable';
import { EncounterTable } from '../baseComponents/Table';
import { columns } from './EncounterColumn';
import { embeddedColumns } from './EmbeddedEncounterColumn';
import { EncounterPatient } from './AddPatientModalV2';
import { LoadingBar } from '../baseComponents/LoadingBar';
import { EncounterRightSidePanel } from './EncounterRightSidePanel';
import EncounterOrders from '../Orders/EncounterOrders';
import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useZoomStatusCheck } from 'src/hooks/zoom/useZoomStatusCheck';
import { useIsOpEhrSyncDisabled } from 'src/hooks/roles/useIsOpEhrSyncDisabled';
import { useNavigate } from 'react-router-dom';
import {
  useAuth,
  useFeatureEntitlements,
  usePermissionEntitlements,
} from '@frontegg/react';
import { useDispatch } from 'react-redux';
import { updateEncounter } from '../../store/actions/encounter';
import { doStream } from '../../utils/listen';
import {
  Alert,
  Dropdown,
  Menu,
  Pagination,
  Popover,
  Spin,
  Tooltip,
} from 'antd';
import { selectedEncounterSlice } from '../../store/slices/encounter';
import {
  AudioOutlined,
  LoadingOutlined,
  PlayCircleOutlined,
  LockOutlined,
  PlusOutlined,
  EllipsisOutlined,
  MailOutlined,
  PictureOutlined,
  DiffOutlined,
  FileAddOutlined,
  SwapOutlined,
} from '@ant-design/icons';
import AuraFullCalendar from '../AuraCalendarView/AuraFullCalendar';
import { SegmentedTabs } from './SegmentedTabs';
import { DragIcon, PdfIcon } from '../../../../icons';
import { showToastInfo, showToastSuccess } from '../../../../utilities/toast';
import moment from 'moment';
import { EncounterSummaryMagicEdit } from '../CurrentEncounter/Encounter.Summary.MagicEdit';
import {
  exportSummaryPDF,
  regenerateSummary,
} from '../../store/actions/summary';
import { ProIcon } from '../../../../icons/Pro.icon';
import { UpgradeTooltip } from '../Payments/UpgradeTooltip';
import { LockIcon } from '../../../../icons/Lock.icon';
import { submitDocumentToEHRIntegration } from '../../../EHR/store/actions/ehr';
import EHRResponseModal from './EHRResponseModal';
import { SummaryUpdatedStatus } from './SummaryUpdatedStatus';
import MedicalConversationBox from '../baseComponents/MedicalConversationBox';
import CurrentTranscript from '../baseComponents/CurrentTranscript';
import MicrophoneBar from './MicrophoneBar';
import { isEmpty } from 'lodash-es';
import { endStream } from '../../utils/listen';
import {
  isAllowedToGenerateSummary,
  isAllowedToStartEncounter,
  isAllowedToCreateEncounter,
} from './permissions';
import { analytics, logger } from 'src/services';
import { copyRichTextToClipboard, sanitizeSummaryAsHtml } from 'src/utils';
import { LanguageSelector } from './LanguageSelector';
import LogoManagementDrawer from 'src/modules/SuperAdmin/components/pageComponents/SuperAdmin/Organization/LogoManagementDrawer';
import TemplateTableWrapper from '../baseComponents/DocumentGenerationWrapper';
import { clearTemplateError } from '../../store/slices/templateSlice';
import { UpgradeButton } from '../Payments/UpgradeButton';
import SendEmailDrawer from './SendEmailDrawer';
import { Activity } from '@insight-health-ai/roseate/icons';
import { setMicLevel } from 'src/store/slices/microphone.slice';

import EHRSubmissionDropdown from './EHRSubmissionDropdown';
import OPEhrSuccessMessage from './OPEhrSuccessMessage';

import { useIsOP } from 'src/hooks/misc/useTenant';
import { useEmbeddedEncounter } from 'src/hooks/embedded/login';
import { useSelectedEncounter } from 'src/hooks/embedded/useSelectedEncounter';
import { useEhrSaveDelay } from 'src/hooks/embedded/useEhrSaveDelay';
import { useResolvedVerbosity } from 'src/hooks/encounter/useResolvedEncounterConfig';

const EncounterDesktopView = ({
  storedFilter,
  schedulepage,
  showOnboardingModal,
  getOnboardingModal,
  auraDemoOpen,
  startDate,
  endDate,
  searchFilters,
  selectedPractitioner,
  savedStartDate,
  savedEndDate,
  handleCreateEncounter,
  storedParams,
  isRowDoubleClicked,
  auraView,
  setSearchFilters,
  setStartDate,
  setAuraView,
  setIsMinimized,
  setCurrentEncounter,
  livePartialTranscript,
  encounterPhase,
  setEndDate,
  handleBackMobileIconClick,
  topBarInputs,
  setTopBarInputs,
  encounterStatus,
  activeButton,
  setActiveButton,
  encounterListWithColors,
  setPageState,
  setSelectedPractitioner,
  handleCancelModal,
  modalVisible,
  isCustomSelected,
  setIsCustomSelected,
  setModalVisible,
  selectedDate,
  liveTranscript,
  setFullTranscript,
  restrictTemplates,
  setLivePartialTranscript,
  record,
  recentSearchList,
  setSavedEndDate,
  fullTranscript,
  setIsStreaming,
  setLiveTranscript,
  setSavedStartDate,
  setRecord,
  setIsRecording,
  isRecording,
  isStreaming,
  changeEncounterStatus,
  setEncounterStatus,
  setSelectedDate,
  handleRowDoubleClick,
  humanScribeStatus,
  editingRow,
  setEditingRow,
  handleCancelEdit,
  selectedEncounterValue,
  medicalConversationBoxRef,
  activeRightPanelTab,
  setActiveRightPanelTab,
  editedSummary,
  handleQrCodeOpen,
  pageState,
  onDemoEncounterTrigger,
  recordingTabs,
  editableSummaryRef,
  isMagicEditingRef,
  autoResumeVisit,
  onAutoResumeComplete,
  isSaving,
  isSummaryOutdated,
  dictationStarted,
  handleDictation,
  waitingForSocketConnection,
  handleRollback,
  isRollingBack,
  handleSummaryEdits,
  showMicrophoneBar,
  isChartRecording,
  isChartStreaming,
  isVisitRecording,
  isVisitStreaming,
  setIsChartStreaming,
  setIsChartRecording,
  setIsVisitRecording,
  setIsVisitStreaming,
  patientDetails,
  handleEditTranscription,
  setwaitingForSocketConnection,
  setDictationStarted,
  isDictateTooltipOpen,
  suggestions,
  isScribeSelected,
  setIsScribeSelected,
  restrictNoteAccess,
  handleEncountersSorting,
  sortState,
  setIsUpgradeModalVisible,
  isTranscribing,
  initTranscript,
  handleUpgradeToProModal,
  settingsOrgValue,
  ehrSettings,
}) => {
  const {
    encounterList,
    encounterListCount,
    isEncounterListLoading,
    selectedEncounter,
    pinnedEncounterIds,
    pinnedEncounterList,
    isPinnedEncounterListLoading,
  } = useSelector((state) => state?.encounterState);
  const { transcriptionbyIdValue } = useSelector(
    (state) => state?.encounterState
  );

  const { currentPractitioner, currentPractitionerSettings } = useSelector(
    (state) => state?.practitionerState
  );

  const { ehrSubmitDocument } = useSelector((state) => state?.ehrState);
  const { getUuid } = useSelector((state) => state?.appointmentState);

  const { verbosity: resolvedVerbosity } = useResolvedVerbosity({
    practitioner_id: record?.practitioner_id,
    encounter_verbosity: record?.summary_verbosity,
    currentPractitionerSettings,
    currentPractitionerId: currentPractitioner?.practitioner_id,
  });

  const { isSummaryRegenerationLoading, summaryExportLoading } = useSelector(
    (state) => state?.summaryState
  );
  const { quota, timeQuota } = useSelector((state) => state?.quotaState);

  const { isEmbeddedWithEncounter } = useEmbeddedEncounter();

  // Selected encounter storage (uses sessionStorage for window isolation)
  const { setSelectedEncounter } = useSelectedEncounter(
    currentPractitioner?.org_uuid
  );

  // Filter out pinned encounters from the regular list to avoid duplication
  const filteredEncounterList = useMemo(() => {
    if (!pinnedEncounterList?.length) return encounterList;
    const pinnedIds = new Set(
      pinnedEncounterList.map((enc) => enc.encounter_id)
    );
    return (
      encounterList?.filter((enc) => !pinnedIds.has(enc.encounter_id)) || []
    );
  }, [encounterList, pinnedEncounterList]);

  const isSmallScreen = window.innerWidth <= 1536;
  const isMobileView = window.innerWidth <= 1260;
  const showSegmentedTabs = schedulepage ? false : true;
  const inVisitRef = useRef(null);
  const containerRef = useRef(null);

  const [selectedRecord, setSelectedRecord] = useState();
  const [hoveredRowIndex, setHoveredRowIndex] = useState(null);
  const [hoveredPinnedRowIndex, setHoveredPinnedRowIndex] = useState(null);
  const [buttonSmall, setButtonSmall] = useState(false);
  const [_isModalVisible, setIsModalVisible] = useState(false);
  const [settingsDropdownVisible, setSettingsDropdownVisible] = useState(false);
  const [logoDrawerVisible, setLogoDrawerVisible] = useState(false);

  const [currentActive, setCurrentActive] = useState('');
  //   const [isDictateTooltipOpen, setIsDictateTooltipOpen] = useState(false);

  const [isEHRResponseModalVisible, setIsEHRResponseModalVisible] =
    useState(false);
  const [ehrSubmitDocumentMessage, setEhrSubmitDocumentMessage] =
    useState(null);
  const [summaryEvidences, setSummaryEvidences] = useState(null);
  const [isSegmentDisabled, setIsSegmentDisabled] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedPinnedRowKeys, setSelectedPinnedRowKeys] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [templatePopupOpen, setTemplatePopupOpen] = useState(false);
  const [manageDocumentDropdownVisible, setManageDropdownVisible] =
    useState(false);
  const [templateCount, setTemplateCount] = useState(0);
  const [ehrSubmissionTooltip, setEhrSubmissionTooltip] = useState({
    open: false,
    message: '',
    status: 'idle',
  });
  const dispatch = useDispatch();
  const { user } = useAuth();
  const isOpEhrSyncDisabled = useIsOpEhrSyncDisabled();
  const { isEntitled: isHumanScribeEntitled } =
    useFeatureEntitlements('custom-workflow');
  const { isEntitled: isRetryDemoEntitled } =
    useFeatureEntitlements('retry-demo');
  const { isEntitled: isDictationEntitled } =
    useFeatureEntitlements('dictation');

  const { isEntitled: isOPPushEhrEnabled } = useFeatureEntitlements(
    'is_op_push_ehr_enabled'
  );

  const zoomStatus = useZoomStatusCheck(
    900000, // Check every 15 minutes
    currentPractitionerSettings?.note_preferences?.enable_zoom_integration ===
      true
  );
  const navigate = useNavigate();
  const isOP = useIsOP();

  // Permission entitlements for start/resume encounters
  const { isEntitled: canStartInVisitEncounter } = usePermissionEntitlements(
    'encounter.in-visit.start'
  );
  const { isEntitled: canStartPreChartEncounter } = usePermissionEntitlements(
    'encounter.pre-chart.start'
  );
  const { isEntitled: canStartDictationEncounter } = usePermissionEntitlements(
    'encounter.dictation.start'
  );

  // Permission entitlements for generating summaries
  const { isEntitled: canGenerateInVisitSummary } = usePermissionEntitlements(
    'encounter.in-visit.generate'
  );
  const { isEntitled: canGeneratePreChartSummary } = usePermissionEntitlements(
    'encounter.pre-chart.generate'
  );
  const { isEntitled: canGenerateAfterVisitSummary } =
    usePermissionEntitlements('encounter.after-visit.generate');

  const { isEntitled: canCreateEncounter } =
    usePermissionEntitlements('encounter.create');

  const isCreateEncounterAllowed = useMemo(() => {
    return isAllowedToCreateEncounter({
      remainingEncounters: quota?.encounters?.remaining,
      remainingDays: timeQuota?.remaining_days,
      canCreateEncounter,
    });
  }, [
    quota?.encounters?.remaining,
    timeQuota?.remaining_days,
    canCreateEncounter,
  ]);

  const isSummaryGenerationAllowed = useMemo(() => {
    return isAllowedToGenerateSummary({
      encounterPhase,
      canGenerateInVisitSummary,
      canGeneratePreChartSummary,
      canGenerateAfterVisitSummary,
    });
  }, [
    encounterPhase,
    canGenerateInVisitSummary,
    canGeneratePreChartSummary,
    canGenerateAfterVisitSummary,
  ]);

  const isStartEncounterAllowed = useMemo(() => {
    return isAllowedToStartEncounter({
      encounterPhase,
      canStartInVisitEncounter,
      canStartPreChartEncounter,
    });
  }, [encounterPhase, canStartInVisitEncounter, canStartPreChartEncounter]);

  const [activePopover, setActivePopover] = useState(null);
  const { currentPractitionerEntitlements } = useSelector(
    (state) => state?.practitionerState
  );
  const isAuraPro = currentPractitionerEntitlements?.plans?.some(
    (plan) => plan?.metadata?.type == 'pro'
  );

  const handleShowUpgradeTooltip = (element) => {
    if (!isAuraPro) {
      setActivePopover(element);
    }
  };

  const handleHideUpgradeTooltip = () => {
    setActivePopover(null);
  };

  // When scribe user clicks on a completed encounter, update the status to In Progress
  const autoChangeStatusToInProgress = (record) => {
    if (!isHumanScribeEntitled) return;

    const isScribeUser = user?.roles?.some((role) => role.key === 'scribe');

    const scribeInProgressStatusId = 'in_progress';

    if (
      isScribeUser &&
      scribeInProgressStatusId &&
      record?.encounter_status === 'completed'
    ) {
      const params = {
        ...storedParams,
      };

      const payload = {
        encounter_status: scribeInProgressStatusId,
      };

      if (!record?.assigned_scribe_id) {
        payload.assigned_scribe_id = currentPractitioner?.practitioner_id;
      }

      dispatch(
        updateEncounter(
          record.encounter_id,
          encounterPhase,
          payload,
          params,
          false
        )
      );
    }
  };

  //Functions to change description of an encounter
  const handleDescriptionChange = (e, record) => {
    const updatedEncounter = { ...record, description: e.target.value };
    setEditingRow(updatedEncounter);
  };

  const handleSaveDescription = (record) => {
    const params = {
      ...storedParams,
    };
    if (!editingRow.description.trim()) {
      toast.error('Description cannot be empty!');
      return;
    }

    if (schedulepage) {
      analytics.track("Edited Encounter's Description From VCA", {
        email: user?.email,
      });
    } else {
      analytics.track("Edited Encounter's Description From Aura", {
        email: user?.email,
      });
    }

    dispatch(
      updateEncounter(
        record.encounter_id,
        encounterPhase,
        { description: editingRow.description },
        params,
        selectedPractitioner,
        false
      )
    );
    setEditingRow(null);
  };
  //Functions to change description of an encounter

  //Functions to change start_time of Calendar events on dragging
  const handleCalendarEventDateChange = (newStartEventDate, eventRecord) => {
    const params = {
      ...storedParams,
    };
    dispatch(
      updateEncounter(
        eventRecord?.encounter_id,
        encounterPhase,
        { start_time: newStartEventDate },
        params,
        selectedPractitioner,
        false
      )
    );
  };

  const retryDemoJsx =
    isRetryDemoEntitled && encounterListCount < 5 ? (
      <div className="flex justify-center items-center w-full">
        <button
          disabled={isEncounterListLoading || !!auraDemoOpen}
          onClick={() => {
            analytics.track('Clicked Retry Demo From Aura', {
              mobile: isMobileView,
              email: user?.email,
            });
            onDemoEncounterTrigger();
          }}
          className="ih-button-ghost gap-2 text-[#5a8dda] underline"
        >
          <PlayCircleOutlined />
          Retry Demo
        </button>
      </div>
    ) : null;

  const handlePauseResumeToggle = useCallback(() => {
    dispatch(
      updateEncounter(record?.encounter_id, encounterPhase, {
        in_visit_status: 'inprogress',
      })
    );
    // updateEncounterFunc(dispatch);
    analytics.track('Clicked Resume after complete button for Aura', {
      encounter_id: record?.encounter_id,
      email: user?.email,
    });
    inVisitRef.current?.handlePauseResumeToggle();
  }, [inVisitRef, inVisitRef.current, dispatch]);

  // Direct recording start function
  const startRecordingDirectly = useCallback(() => {
    if (!record?.encounter_id) return;

    let data = {
      summary_verbosity: resolvedVerbosity,
      summary_format:
        record?.summary_format ||
        currentPractitionerSettings?.ambient_in_visit_summary_format,
      template_id:
        record?.in_visit_template_id ||
        currentPractitionerSettings?.ambient_in_visit_template_id,
      template_overrides_id:
        record?.in_visit_template_overrides_id ||
        currentPractitionerSettings?.ambient_in_visit_template_overrides_id,
    };

    return dispatch(
      updateEncounter(
        record.encounter_id,
        'in-visit',
        data,
        storedParams,
        false
      )
    ).then(() => {
      return new Promise((resolve, reject) => {
        doStream({
          encounterId: record.encounter_id,
          encounterPhase: 'in-visit',
          setMicLevel: (level) => dispatch(setMicLevel(level)),
          setLiveTranscript,
          setLivePartialTranscript,
          selectedMicrophoneId: null,
          successCallback: () => {
            setIsVisitStreaming(true);
            setIsVisitRecording(true);

            analytics.track(
              'Auto Started Aura Visit Recording From VCA Direct',
              {
                encounter_id: record.encounter_id,
                email: user?.email,
              }
            );
            resolve(true);
          },
          failureCallback: (error) => {
            logger.error('Failed to start recording:', {
              encounter_id: record.encounter_id,
              email: user?.email,
              error,
            });
            reject();
          },
          setDictation: () => {},
          isDictate: false,
          transcriptTimeoutCallback: (error) => {
            console.error('Transcript timeout:', error);
          },
        });
      });
    });
  }, [
    record?.encounter_id,
    dispatch,
    user?.email,
    setIsVisitStreaming,
    setIsVisitRecording,
    setLiveTranscript,
    setLivePartialTranscript,
  ]);

  useEffect(() => {
    if (autoResumeVisit && record?.encounter_id) {
      startRecordingDirectly().finally(() => {
        onAutoResumeComplete?.();
      });
    }
  }, [autoResumeVisit, record?.encounter_id]);

  //Function to copy contents from medical notes to the clipboard
  const handleCopy = async () => {
    if (schedulepage) {
      analytics.track(
        'Clicked Copy As Rich Text In Ambient Medical Notes From VCA',
        {
          transcription: transcriptionbyIdValue[0]?.transcription_id,
          email: user?.email,
        }
      );
    } else {
      analytics.track(
        'Clicked Copy As Rich Text In Ambient Medical Notes From Aura',
        {
          transcription: transcriptionbyIdValue[0]?.transcription_id,
          email: user?.email,
        }
      );
    }

    if (
      (!editableSummaryRef.current?.summary_json ||
        editableSummaryRef.current?.summary_json?.trim() === '') &&
      !getUuid?.appointment_details?.llm_intake_summary_forms
    ) {
      toast.info('No data available to copy');
      return;
    }

    try {
      let medicalConversation = editableSummaryRef.current?.summary_json;

      if (
        getUuid?.appointment_details?.llm_intake_summary_forms &&
        encounterPhase === 'in-visit'
      ) {
        medicalConversation +=
          getUuid?.appointment_details?.llm_intake_summary_forms;
      }

      const additionalInfo = `<strong>Encounter Name:</strong> ${
        record.description
      }<br><strong>Date:</strong> ${moment(record.created_at).format(
        'MMM Do, YYYY'
      )}`;

      await copyRichTextToClipboard(
        sanitizeSummaryAsHtml(medicalConversation, {
          prefix: additionalInfo,
        })
      );
      toast.success('Copied to clipboard');
    } catch (error) {
      toast.error('Failed to copy medical notes');
    }
  };

  const MedicalCopyOptions = () => {
    return (
      <Menu
        onClick={({ key }) => {
          if (key === 'copy-editor') {
            handleCopy();
          }
        }}
      >
        <Menu.Item key="copy-editor">
          <span className="dropdown-text">Copy as rich text</span>
        </Menu.Item>
      </Menu>
    );
  };

  const handleExportPDF = () => {
    if (schedulepage) {
      analytics.track(
        'Clicked Export PDF In Ambient Medical Conversation From VCA ',
        {
          encounter: record?.encounter_id,
          email: user?.email,
        }
      );
    } else {
      analytics.track(
        'Clicked Export PDF In Ambient Medical Conversation From Aura',
        {
          encounter: record?.encounter_id,
          email: user?.email,
        }
      );
    }
    dispatch(exportSummaryPDF(record?.encounter_id, encounterPhase));
  };

  const handleMedicalNotesCopy = () => {
    if (schedulepage) {
      analytics.track(
        'Clicked Copy All To Clipboard In Ambient Medical Notes From VCA',
        {
          transcription: transcriptionbyIdValue[0]?.transcription_id,
          email: user?.email,
        }
      );
    } else {
      analytics.track(
        'Clicked Copy All To Clipboard In Ambient Medical Notes From Aura',
        {
          transcription: transcriptionbyIdValue[0]?.transcription_id,
          email: user?.email,
        }
      );
    }

    if (
      (!editableSummaryRef.current?.summary_json ||
        editableSummaryRef.current?.summary_json?.trim() === '') &&
      !getUuid?.appointment_details?.llm_intake_summary_forms
    ) {
      toast.info('No data available to copy');
      return;
    }
    try {
      let medicalConversation = editableSummaryRef.current?.summary_json;

      if (
        getUuid?.appointment_details?.llm_intake_summary_forms &&
        encounterPhase === 'in-visit'
      ) {
        medicalConversation +=
          getUuid?.appointment_details?.llm_intake_summary_forms;
      }

      // Format encounter name and date
      const encounterName = record.description || 'Unknown Encounter';
      const date = moment(record.created_at).isValid()
        ? moment(record.created_at).format('MMM Do, YYYY')
        : 'Unknown Date';

      const patientName =
        record?.patient?.first_name && record?.patient?.last_name
          ? `${record.patient.first_name} ${record.patient.last_name}`
          : patientDetails?.first_name && patientDetails?.last_name
            ? `${patientDetails.first_name} ${patientDetails.last_name}`
            : 'Unknown';

      const DOB =
        record?.patient?.birth_date || patientDetails?.birth_date || 'Unknown';
      const additionalInfo = `Encounter Name: ${encounterName}\nDate: ${date}\nPatient Name: ${patientName}\nDOB: ${DOB}\n\n`;
      let plainText;
      if (encounterPhase === 'dictate') {
        analytics.track('Clicked Copy All To Clipboard From Solo Dictation', {
          email: user?.email,
        });
        plainText = medicalConversation
          .replace(/<p>/g, '')
          .replace(/```/g, '')
          .replace(/<\/p>/g, '\n')
          .replace(/<strong style="color: rgb\(0, 208, 145\);">/g, '| ')
          .replace(/<\/strong>/g, '')
          .replace(/<strong>/g, '')
          .replace(/<br>/g, '\n')
          .replace(/\n\n+/g, '\n\n') // Remove leading whitespace before '|' character
          .replace(/^\|+/gm, '')
          .replace(/&amp;/g, '&')
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/&quot;/g, '"')
          .replace(/&apos;/g, "'")
          .replace(/&nbsp;/g, ' ')
          .replace(/&cent;/g, '¢')
          .replace(/&pound;/g, '£')
          .replace(/&yen;/g, '¥')
          .replace(/&euro;/g, '€')
          .replace(/&copy;/g, '©')
          .replace(/&reg;/g, '®')
          .replace(/&trade;/g, '™')
          .trim();
      } else {
        plainText =
          additionalInfo +
          medicalConversation
            .replace(/<p>/g, '')
            .replace(/```/g, '')
            .replace(/<\/p>/g, '\n')
            .replace(/<strong style="color: rgb\(0, 208, 145\);">/g, '| ')
            .replace(/<\/strong>/g, '')
            .replace(/<strong>/g, '')
            .replace(/<strong style="color: #00d091;">/g, '| ')
            .replace(/<strong style='color: #00d091;'>/g, '| ')
            .replace(/<strong style="color: #000;">/g, '')
            .replace(/<strong style='color: #000;'>/g, '')
            .replace(/<br>/g, '\n')
            .replace(/\n\n+/g, '\n\n') // Remove leading whitespace before '|' character
            .replace(/^\|+/gm, '')
            .replace(/&amp;/g, '&')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&quot;/g, '"')
            .replace(/&apos;/g, "'")
            .replace(/&nbsp;/g, ' ')
            .replace(/&cent;/g, '¢')
            .replace(/&pound;/g, '£')
            .replace(/&yen;/g, '¥')
            .replace(/&euro;/g, '€')
            .replace(/&copy;/g, '©')
            .replace(/&reg;/g, '®')
            .replace(/&trade;/g, '™')
            .trim();
      }

      // Create a temporary textarea element
      const tempTextArea = document.createElement('textarea');
      tempTextArea.style.position = 'fixed';
      tempTextArea.style.opacity = '0';
      tempTextArea.value = plainText;

      document.body.appendChild(tempTextArea);

      // Select and copy the content from the temporary textarea
      tempTextArea.select();
      document.execCommand('copy');

      document.body.removeChild(tempTextArea);
      if (!record?.encounter_ehr_data) {
        dispatch(
          updateEncounter(record?.encounter_id, encounterPhase, {
            encounter_status: 'copied_to_ehr',
          })
        );
      }
      toast.success('Copied to clipboard');
    } catch (error) {
      toast.error('Failed to copy medical notes');
    }
  };

  const getCurrentTemplate = () => {
    if (encounterPhase === 'pre-chart') {
      return {
        template_id: record?.pre_chart_template_id,
        template_overrides_id: record?.pre_chart_template_overrides_id,
      };
    } else if (encounterPhase === 'in-visit') {
      return {
        template_id: record?.in_visit_template_id,
        template_overrides_id: record?.in_visit_template_overrides_id,
      };
    } else if (encounterPhase === 'after-visit') {
      return {
        template_id: record?.after_visit_template_id,
        template_overrides_id: record?.after_visit_template_overrides_id,
      };
    }
  };

  const handleRegenerate = (mode = 'update') => {
    if (schedulepage) {
      analytics.track(
        'Clicked Regenerate Summary In Ambient Medical Conversation From VCA ',
        {
          encounter: record?.encounter_id,
          mode: mode,
          email: user?.email,
        }
      );
    } else {
      analytics.track(
        'Clicked Regenerate Summary In Ambient Medical Conversation From Aura',
        {
          encounter: record?.encounter_id,
          mode: mode,
          email: user?.email,
        }
      );
    }
    dispatch(
      regenerateSummary(
        record?.encounter_id,
        encounterPhase,
        storedParams,
        '',
        getCurrentTemplate(),
        resolvedVerbosity,
        record?.summary_format,
        mode
      )
    );
    setEncounterStatus('summary_inprogress');
  };

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleCalendarEventClick = (record) => {
    setRecord(record);
    setIsStreaming(false);
    setIsRecording(false);
    setCurrentEncounter(record);
    autoChangeStatusToInProgress(record);
  };

  const handleSubmitToEHR = async (selectedSections = null) => {
    if (isOpEhrSyncDisabled) return;
    analytics.track('Clicked Save To EHR Button', {
      encounter_id: record?.encounter_id,
      email: user?.email,
    });

    setIsSubmitting(true);
    setEhrSubmissionTooltip({
      open: true,
      message: 'Submitting Diagnoses to EHR...',
      status: 'loading',
    });

    if (icd10CodingRef.current) {
      const icdResult = await icd10CodingRef.current.submitToEHR();
      if (!icdResult.success) {
        setEhrSubmissionTooltip({
          open: true,
          message: icdResult.message,
          status: 'error',
        });
        setIsSubmitting(false);
        return;
      }
    }

    setEhrSubmissionTooltip({
      open: true,
      message: 'Submitting Document to EHR...',
      status: 'loading',
    });

    const appointmentId =
      record?.encounter_ehr_data?.appointment_id || record?.appointment_id;
    const data = {
      appointment_id: appointmentId,
      document_data: editableSummaryRef.current.summary_json,
      document_subclass: 'PROGRESSNOTE',
      encounter_ehr_id: record?.ehr_id,
      encounter_id: record?.encounter_id,
    };

    if (selectedSections && Array.isArray(selectedSections)) {
      data.selected_sections = selectedSections;
    }

    const submitDocumentHandler = submitDocumentToEHRIntegration(data);
    submitDocumentHandler(dispatch).finally(() => {
      setIsSubmitting(false);
      restartEhrSaveDelay();
    });
  };

  const handleModalOk = () => {
    setIsModalVisible(false);
    setIsEHRResponseModalVisible(false);
    if (isOpEhrSyncDisabled) return;
    setIsSubmitting(true);
    const appointmentId =
      record?.encounter_ehr_data?.appointment_id || record?.appointment_id;
    const data = {
      appointment_id: appointmentId,
      document_data: editableSummaryRef.current.summary_json,
      document_subclass: 'PROGRESSNOTE',
      skip_document_split: true,
      encounter_id: record?.encounter_id,
    };
    const submitDocumentHandler = submitDocumentToEHRIntegration(data);
    submitDocumentHandler(dispatch).finally(() => {
      setIsSubmitting(false);
      restartEhrSaveDelay();
    });
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
    setIsEHRResponseModalVisible(false);
  };

  const handleTranscriptionCopy = () => {
    if (schedulepage) {
      analytics.track(
        'Clicked Copy All To Clipboard In Ambient Transcript From VCA',
        {
          transcription: transcriptionbyIdValue[0]?.transcription_id,
          email: user?.email,
        }
      );
    } else {
      analytics.track(
        'Clicked Copy All To Clipboard In Ambient Transcript From Aura',
        {
          transcription: transcriptionbyIdValue[0]?.transcription_id,
          email: user?.email,
        }
      );
    }

    const transcription = transcriptionbyIdValue[0];
    if (
      !transcription ||
      !transcription.transcription_json ||
      !transcription.transcription_json.length
    ) {
      showToastInfo('No transcription data available');
      return;
    }

    // Format encounter name and date
    const encounterName = record?.description || 'N/A';
    const createdAt = record?.created_at
      ? moment(record.created_at).format('MMM Do, YYYY')
      : 'N/A';
    const additionalInfo = `Encounter Name: ${encounterName}\nDate: ${createdAt}\n\n`;

    // Generate plain text transcription
    const textToCopy =
      additionalInfo +
      transcriptionbyIdValue[0]?.transcription_json
        .map(
          (transcription) =>
            `Speaker ${transcription.speaker}:\n${transcription.text}`
        )
        .join('\n\n');

    // Format HTML transcription for clipboard
    const htmlToCopy = textToCopy.replace(/\n/g, '<br>').trim();

    // Write both plain text and HTML to clipboard
    navigator.clipboard.write([
      new ClipboardItem({
        'text/plain': new Blob([textToCopy], { type: 'text/plain' }),
        'text/html': new Blob([htmlToCopy], { type: 'text/html' }),
      }),
    ]);

    showToastSuccess('Transcription copied to clipboard');
  };
  //Function to copy contents from transcriptions to the clipboard
  const transcriptcopy = () => {
    if (schedulepage) {
      analytics.track(
        'Clicked Copy As Rich Text In Ambient Transcript From VCA',
        {
          transcription: transcriptionbyIdValue[0]?.transcription_id,
          email: user?.email,
        }
      );
    } else {
      analytics.track(
        'Clicked Copy As Rich Text In Ambient Transcript From Aura',
        {
          transcription: transcriptionbyIdValue[0]?.transcription_id,
          email: user?.email,
        }
      );
    }

    const transcription = transcriptionbyIdValue[0];
    if (
      !transcription ||
      !transcription.transcription_json ||
      !transcription.transcription_json.length
    ) {
      showToastInfo('No transcription data available');
      return;
    }
    const encounterName = record?.description || 'N/A';
    const createdAt = record?.created_at
      ? moment(record.created_at).format('MMM Do, YYYY')
      : 'N/A';
    const additionalInfo = `<strong>Encounter Name:</strong> ${encounterName}<br><strong>Date:</strong> ${createdAt}<br><br>`;
    const textToCopy =
      additionalInfo +
      transcriptionbyIdValue[0]?.transcription_json
        .map(
          (transcription) =>
            `Speaker ${transcription.speaker}:\n${transcription.text}`
        )
        .join('\n\n');
    const htmlToCopy = textToCopy.replace(/\n/g, '<br>').trim();
    navigator.clipboard.write([
      new ClipboardItem({
        'text/plain': new Blob([textToCopy], { type: 'text/plain' }),
        'text/html': new Blob([htmlToCopy], { type: 'text/html' }),
      }),
    ]);
    showToastSuccess('Transcription copied to clipboard');
  };

  const TranscriptCopyOptions = () => {
    return (
      <Menu
        onClick={({ key }) => {
          if (key === 'transcript-text-editor') {
            transcriptcopy();
          }
        }}
      >
        <Menu.Item key="transcript-text-editor">
          <span className="dropdown-text">Copy as rich text</span>
        </Menu.Item>
      </Menu>
    );
  };

  const triggerShowSummaryEvidence = (evidences) => {
    if (!isEmpty(evidences)) {
      setSummaryEvidences(evidences);
      setActiveRightPanelTab('live');
    }
  };

  const resetSummaryEvidence = useCallback(() => {
    setSummaryEvidences(null);
  }, []);

  const getSummaryVerbosity = () => {
    return resolvedVerbosity;
  };

  const handleOpenDrawer = () => {
    setDrawerOpen(true);
    dispatch(clearTemplateError());
  };

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setTemplatePopupOpen(false); // Also close popup when drawer closes
  };

  const DateOptions = [
    {
      title: 'Today',
      value: 'Today',
      className:
        'h-8  flex items-center justify-center rounded-full hover:bg-[#f7f7f7]',
    },
    {
      title: 'Yesterday',
      value: 'Yesterday',
      className:
        'h-8  flex items-center justify-center rounded-full hover:bg-[#f7f7f7]',
    },
    {
      title: 'Past 7 days',
      value: 'Past 7 days',
      className:
        'h-8  flex items-center justify-center rounded-full hover:bg-[#f7f7f7]',
    },
    {
      title: 'Custom…🗓️',
      value: 'Custom…🗓️',
      className:
        'h-8  flex items-center justify-center rounded-full hover:bg-[#f7f7f7]',
    },
  ];

  useLayoutEffect(() => {
    if (containerRef.current) {
      setButtonSmall(containerRef.current.offsetWidth < 700);
    }
  }, [containerRef.current, containerRef.current?.offsetWidth]);

  useEffect(() => {
    let timer;
    if (ehrSubmitDocument?.response) {
      if (ehrSubmitDocument.response.success) {
        setEhrSubmissionTooltip({
          open: true,
          message: isOP
            ? 'Submitted to EHR. Refresh your OP note right away.'
            : 'Document submitted to EHR successfully!',
          status: 'success',
        });
        // OP users need to read the refresh warning, so linger longer.
        timer = setTimeout(
          () => {
            setEhrSubmissionTooltip({
              open: false,
              message: '',
              status: 'idle',
            });
          },
          isOP ? 10000 : 2000
        );
      } else {
        setEhrSubmissionTooltip({ open: false, message: '', status: 'idle' });
        setIsEHRResponseModalVisible(true);
        setEhrSubmitDocumentMessage(ehrSubmitDocument.response);
      }
      setIsSubmitting(false);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [ehrSubmitDocument?.response, isOP]);

  useEffect(() => {
    if (isChartStreaming || isChartRecording) setCurrentActive('Pre-chart');
    else if (isVisitStreaming || isVisitRecording) setCurrentActive('In-visit');
  }, [isChartRecording, isChartStreaming, isVisitRecording, isVisitStreaming]);

  const handleLogoChangeClick = () => {
    setSettingsDropdownVisible(false);
    setLogoDrawerVisible(true);
    handleHideUpgradeTooltip();
  };

  const icd10CodingRef = useRef(null);

  const getEncounterDetails = (record) => {
    const practitionerDetail = record.practitioner_name;
    return (
      <div className="border-b bg-gray-50 px-3 py-2 flex justify-between items-center">
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2 text-sm">
            <div className="font-medium">{record?.description || null}</div>
          </div>
          <div className="text-xs empty:hidden flex flex-col gap-1 mt-1">
            <span className="text-gray-500 flex gap-1">
              <AudioOutlined />
              {practitionerDetail}
            </span>
            {record?.zoom_meeting_id &&
              (record?.in_visit_status === 'new' ||
                record?.in_visit_status === 'inprogress') && (
                <span className="text-[#5A8DDA] flex items-start gap-1">
                  <Spin
                    indicator={
                      <LoadingBar color="#5A8DDA" height="14" width="14" />
                    }
                    size="small"
                  />
                  <span>
                    Waiting for zoom meeting recording to be available
                    <p className="text-xs text-gray-500">
                      Please come back after sometime.
                    </p>
                  </span>
                </span>
              )}
            {/* <div
              className="text-xs"
              style={{
                color: isHumanScribeEntitled ? fullEncounterColor : color,
              }}
            >
              {isHumanScribeEntitled ? fullEncounterStatus : displayStatus}
            </div> */}
          </div>
        </div>
        <div className="text-xs text-gray-500 empty:hidden">
          <span className="text-gray-500">
            <EncounterPatient encounter={record} onUpdate={setRecord} />
          </span>
        </div>
      </div>
    );
  };

  const [isSendEmailDrawerOpen, setIsSendEmailDrawerOpen] = useState(false);
  const [showSaveDeleteButtons, setShowSaveDeleteButtons] = useState(false);

  const renderEncounterPanelContent = () => {
    const currentTranscriptProps = {
      encounterPhase,
      encounterStatus,
      storedParams,
      selectedRecord: record,
      topBarInputs,
      setRecord,
      setEncounterStatus,
      setLiveTranscript,
      setLivePartialTranscript,
      autoResumeVisit,
      setActiveRightPanelTab,
      isStreaming,
      setIsStreaming,
      isChartStreaming,
      isVisitStreaming,
      setIsChartStreaming,
      setIsVisitStreaming,
      isRecording,
      setIsRecording,
      isChartRecording,
      isVisitRecording,
      setIsChartRecording,
      setIsVisitRecording,
      schedulepage,
      restrictTemplates,
      patientDetails,
      settingsOrgValue,
      ref: inVisitRef,
      showSaveDeleteButtons,
      setShowSaveDeleteButtons,
    };

    if (encounterPhase === 'pre-chart') {
      return (
        <div
          className={`flex h-full flex-col overflow-y-auto items-center justify-evenly`}
        >
          <CurrentTranscript {...currentTranscriptProps} />
        </div>
      );
    }

    // Render Orders component when on Orders tab
    if (encounterPhase === 'orders') {
      return (
        <EncounterOrders
          encounterId={selectedEncounter?.encounter_id}
          onSaveToEHR={() => {
            // TODO: Implement save to EHR functionality for orders
            console.log('Save orders to EHR');
          }}
        />
      );
    }

    return encounterStatus === 'completed' ||
      encounterStatus === 'summary_inprogress' ||
      encounterPhase === 'dictate' ? (
      <>
        <MedicalConversationBox
          key={encounterPhase}
          ref={medicalConversationBoxRef}
          encounterPhase={encounterPhase}
          handleDictation={isDictationEntitled ? handleDictation : null}
          encounterStatus={encounterStatus}
          summaryVerbosity={getSummaryVerbosity()}
          selectedRecord={record}
          selectedEncounterId={selectedEncounter?.encounter_id}
          medicalConversation={editableSummaryRef.current?.summary_json}
          handleMedicalConversationChange={handleSummaryEdits}
          setIsSegmentDisabled={setIsSegmentDisabled}
          encounterId={selectedEncounter?.encounter_id}
          schedulepage={schedulepage}
          summaryId={editableSummaryRef.current?.summary_id}
          activeButton={activeButton}
          triggerShowSummaryEvidence={triggerShowSummaryEvidence}
          transcriptionbyIdValue={transcriptionbyIdValue}
        />
        {encounterPhase !== 'dictate' && encounterPhase !== 'vca-summary' && (
          <CurrentTranscript {...currentTranscriptProps} />
        )}
      </>
    ) : (
      (((encounterStatus !== 'completed' ||
        encounterStatus !== 'summary_inprogress' ||
        encounterStatus === 'inprogress') &&
        encounterList?.length > 0) ||
        pinnedEncounterList?.length > 0) && (
        <div
          className={`flex h-full flex-col overflow-y-auto items-center justify-evenly`}
        >
          <CurrentTranscript {...currentTranscriptProps} />
        </div>
      )
    );
  };

  // OP SSO check - disable Save to OP button if not launched from SSO
  const isOPSaveDisabled = isOP && !record?.ehr_id;

  // Post-launch delay: the EHR data pipeline needs time to make the
  // composition resource available before we can save. Applies to all EHRs.
  const {
    isLocked: isEhrSaveLocked,
    remainingFormatted: ehrSaveCountdown,
    restart: restartEhrSaveDelay,
  } = useEhrSaveDelay(ehrSettings?.ehr_save_delay_ms, record?.encounter_id);
  const isEhrSaveDelayed = isEhrSaveLocked;

  const isOPEhrSuccess = isOP && ehrSubmissionTooltip.status === 'success';

  const getEhrSubmissionTooltip = () => {
    if (isOpEhrSyncDisabled) {
      return 'EHR sync is disabled for your role.';
    }
    if (isOPSaveDisabled) {
      return 'Launch from patient chart in OP to enable saving';
    }
    if (isEhrSaveDelayed) {
      return `Syncing chart details. Save option will unlock in ${ehrSaveCountdown}.`;
    }
    if (isOPEhrSuccess) {
      return <OPEhrSuccessMessage />;
    }
    if (ehrSubmissionTooltip.message) {
      return ehrSubmissionTooltip.message;
    }
    if (record?.encounter_ehr_data?.document_submitted_at) {
      const submittedAt = moment
        .utc(record.encounter_ehr_data.document_submitted_at)
        .local()
        .format('MM/DD/YYYY h:mm A');
      return `${
        isOP ? 'Submitted to OP' : 'Submitted to EHR'
      } at ${submittedAt}`;
    }
    return isOP ? 'Save to OP' : 'Save to EHR';
  };

  return (
    <div
      className={` ${schedulepage ? '' : 'page-wrapper'} past flex flex-col`}
    >
      {!!showOnboardingModal &&
        encounterPhase !== 'vca-summary' &&
        getOnboardingModal()}
      {(!showOnboardingModal || auraDemoOpen?.retry) && (
        <div>
          {encounterList.length === 0 &&
          pinnedEncounterList.length === 0 &&
          startDate === null &&
          encounterPhase !== 'vca-summary' &&
          endDate === null &&
          searchFilters?.practitioner_id === undefined &&
          !searchFilters ? (
            isEncounterListLoading ||
            isPinnedEncounterListLoading ||
            selectedPractitioner === null ||
            savedStartDate === null ||
            savedEndDate === null ? (
              <Bars
                height="25"
                width="25"
                color="#00D090"
                ariaLabel="bars-loading"
                wrapperStyle={{}}
                wrapperClass=" justify-center"
                visible={true}
              />
            ) : isEmbeddedWithEncounter ? (
              <Alert
                message="The encounter linked to this visit could not be found. Please try launching from EHR again."
                type="warning"
                showIcon
                className="m-4"
              />
            ) : (
              <div className="flex justify-center items-center h-screen w-full flex-col ">
                <div className="mb-5">
                  Click on the add encounter button to create a new encounter
                </div>
                <Button
                  type={'button'}
                  className="rounded-xl flex items-center gap-2 cursor-pointer"
                  disabled={!isCreateEncounterAllowed}
                  onClick={() => handleCreateEncounter(storedParams)}
                >
                  <PlusOutlined /> Add encounter
                </Button>
              </div>
            )
          ) : (
            <div
              className={
                encounterPhase === 'vca-summary'
                  ? 'hidden'
                  : 'past-encounter-page-wrapper'
              }
            >
              {!isRowDoubleClicked && encounterPhase !== 'vca-summary' && (
                <div className="">
                  <PastEncounterTopBar
                    storedFilter={storedFilter}
                    setSearchFilters={setSearchFilters}
                    searchFilters={searchFilters}
                    setStartDate={setStartDate}
                    setEndDate={setEndDate}
                    topBarInputs={topBarInputs}
                    setTopBarInputs={setTopBarInputs}
                    encounterStatus={encounterStatus}
                    startDate={startDate}
                    endDate={endDate}
                    activeButton={activeButton}
                    setActiveButton={setActiveButton}
                    handleCreateEncounter={handleCreateEncounter}
                    onCreateEncounter={() =>
                      handleCreateEncounter(storedParams)
                    }
                    selectedEncounterDetails={selectedEncounter}
                    encounterList={encounterList}
                    encounterListWithColors={encounterListWithColors}
                    setPageState={setPageState}
                    selectedPractitioner={selectedPractitioner}
                    setSelectedPractitioner={setSelectedPractitioner}
                    schedulepage={schedulepage}
                    DateOptions={DateOptions}
                    handleCancelModal={handleCancelModal}
                    modalVisible={modalVisible}
                    isCustomSelected={isCustomSelected}
                    setIsCustomSelected={setIsCustomSelected}
                    setModalVisible={setModalVisible}
                    selectedDate={selectedDate}
                    setSelectedDate={setSelectedDate}
                    setEncounterStatus={setEncounterStatus}
                    record={record}
                    changeEncounterStatus={changeEncounterStatus}
                    setRecord={setRecord}
                    setSavedStartDate={setSavedStartDate}
                    setSavedEndDate={setSavedEndDate}
                    recentSearchList={recentSearchList}
                    encounterPhase={encounterPhase}
                    storedParams={storedParams}
                    selectedRecord={record}
                    setLiveTranscript={setLiveTranscript}
                    setLivePartialTranscript={setLivePartialTranscript}
                    isStreaming={isStreaming}
                    setIsStreaming={setIsStreaming}
                    isRecording={isRecording}
                    setIsRecording={setIsRecording}
                    restrictTemplates={restrictTemplates}
                    fullTranscript={fullTranscript}
                    setFullTranscript={setFullTranscript}
                    liveTranscript={liveTranscript}
                    livePartialTranscript={livePartialTranscript}
                    handleRowClick={setCurrentEncounter}
                    auraView={auraView}
                    setAuraView={setAuraView}
                    setIsMinimized={setIsMinimized}
                    humanScribeStatus={humanScribeStatus}
                    isScribeSelected={isScribeSelected}
                    setIsScribeSelected={setIsScribeSelected}
                    setIsUpgradeModalVisible={setIsUpgradeModalVisible}
                    handleUpgradeToProModal={handleUpgradeToProModal}
                  />
                </div>
              )}
              {isRowDoubleClicked ? (
                <div className="">
                  <BackIconMobile onClick={handleBackMobileIconClick} />
                </div>
              ) : null}
              <div className="flex gap-4 h-full overflow-hidden">
                {auraView === 'LIST' ? (
                  !isRowDoubleClicked &&
                  !schedulepage && (
                    <Resizable
                      className="shadow-xl bg-white ant-table-wrappers rounded-xl relative h-full"
                      defaultSize={{ width: '27%' }}
                      minWidth={'25%'}
                      maxWidth={'40%'}
                      enable={{
                        top: false,
                        right: true,
                        bottom: false,
                        left: false,
                        topRight: false,
                        bottomRight: false,
                        bottomLeft: false,
                        topLeft: false,
                      }}
                      handleComponent={{
                        right: (
                          <div className="absolute top-1/2 right-0 mr-3">
                            <DragIcon />
                          </div>
                        ),
                      }}
                    >
                      <div className="h-full flex flex-col overflow-hidden justify-between">
                        <div className="h-full overflow-y-auto">
                          {pinnedEncounterList.length > 0 && (
                            <>
                              <EncounterTable
                                columns={(isEmbeddedWithEncounter
                                  ? embeddedColumns
                                  : columns)({
                                  encounterList: pinnedEncounterList,
                                  humanScribeStatus,
                                  setHoveredRowIndex: setHoveredPinnedRowIndex,
                                  editingRow,
                                  setEditingRow,
                                  handleDescriptionChange,
                                  handleCancelEdit,
                                  storedParams,
                                  handleSaveDescription,
                                  hoveredRowIndex: hoveredPinnedRowIndex,
                                  handleQrCodeOpen,
                                  searchFilters,
                                  schedulepage,
                                  autoChangeStatusToInProgress,
                                  setCurrentEncounter,
                                  setRecord,
                                  setIsStreaming,
                                  setIsRecording,
                                  isHumanScribeEntitled,
                                  encounterPhase,
                                  editedSummary,
                                  selectedRecord,
                                  setSelectedRecord,
                                  setSearchFilters,
                                  currentPractitioner,
                                  pinnedEncounterIds,
                                  dispatch,
                                  needsZoomReauth: zoomStatus?.needsReauth,
                                  navigate,
                                  isEmbeddedWithEncounter,
                                  pinnedEncounterList,
                                  setSelectedEncounter,
                                })}
                                setStartDate={setStartDate}
                                setEndDate={setEndDate}
                                setSearchFilters={setSearchFilters}
                                setTopBarInputs={setTopBarInputs}
                                onCreateEncounter={() =>
                                  handleCreateEncounter(storedParams)
                                }
                                ClassName={'tableai'}
                                onRow={(record) => ({
                                  onDoubleClick: (e) => {
                                    if (e.currentTarget.contains(e.target)) {
                                      handleRowDoubleClick(record);
                                      analytics.track(
                                        'Double Clicked Encounter From List View',
                                        {
                                          email: user?.email,
                                        }
                                      );
                                    }
                                  },
                                })}
                                className="bg-white px-2 [&_.ant-table-tbody]:space-y-2"
                                rowClassName={(record, index) => {
                                  let baseClass = 'bg-[#E9F5F4]';

                                  if (
                                    record?.encounter_id ===
                                    selectedEncounterValue
                                  ) {
                                    baseClass +=
                                      ' selectedAura bg-[#ebecf0] transform transition duration-200 ease-in-out';
                                  } else if (
                                    index >= 0 &&
                                    encounterList[index + 1]?.encounter_id ===
                                      selectedEncounter?.encounter_id
                                  ) {
                                    baseClass += ' selectedAuraTop';
                                  }

                                  if (
                                    selectedPinnedRowKeys.includes(
                                      record?.encounter_id
                                    )
                                  ) {
                                    baseClass += ' row-selected';
                                  }

                                  return baseClass;
                                }}
                                showSorterTooltip={false}
                                dataSource={pinnedEncounterList}
                                loading={{
                                  indicator: <LoadingBar />,
                                  spinning: isPinnedEncounterListLoading,
                                }}
                                locale={{
                                  emptyText: 'No Data',
                                }}
                                tableLayout="auto"
                                sortedInfo={sortState}
                                storedParams={storedParams}
                                selectedRowKeys={selectedPinnedRowKeys}
                                setSelectedRowKeys={setSelectedPinnedRowKeys}
                                settingsOrgValue={settingsOrgValue}
                                isUrgent={true}
                                title={
                                  <div className="font-sans font-medium text-sm flex items-center py-3 pl-4 gap-2">
                                    <PinIcon fill="#1FD0C1" />
                                    Active Encounters
                                    <span className="rounded-full bg-[#E9F5F4] text-[#1FD0C1] min-w-[18px] min-h-[18px] text-xs flex items-center justify-center">
                                      {pinnedEncounterList?.length || 0}
                                    </span>
                                  </div>
                                }
                              />
                              <div className="h-px bg-gray-200 my-4"></div>
                            </>
                          )}
                          <EncounterTable
                            columns={(isEmbeddedWithEncounter
                              ? embeddedColumns
                              : columns)({
                              encounterList: filteredEncounterList,
                              humanScribeStatus,
                              setHoveredRowIndex,
                              editingRow,
                              setEditingRow,
                              handleDescriptionChange,
                              handleCancelEdit,
                              storedParams,
                              handleSaveDescription,
                              hoveredRowIndex,
                              handleQrCodeOpen,
                              searchFilters,
                              schedulepage,
                              autoChangeStatusToInProgress,
                              setCurrentEncounter,
                              setRecord,
                              setIsStreaming,
                              setIsRecording,
                              isHumanScribeEntitled,
                              encounterPhase,
                              editedSummary,
                              selectedRecord,
                              setSelectedRecord,
                              setSearchFilters,
                              currentPractitioner,
                              pinnedEncounterIds,
                              dispatch,
                              needsZoomReauth: zoomStatus?.needsReauth,
                              navigate,
                              isEmbeddedWithEncounter,
                              pinnedEncounterList,
                              setSelectedEncounter,
                            })}
                            setStartDate={setStartDate}
                            setEndDate={setEndDate}
                            setSearchFilters={setSearchFilters}
                            setTopBarInputs={setTopBarInputs}
                            onCreateEncounter={() =>
                              handleCreateEncounter(storedParams)
                            }
                            ClassName={'tableai'}
                            onRow={(record) => ({
                              onDoubleClick: (e) => {
                                if (e.currentTarget.contains(e.target)) {
                                  handleRowDoubleClick(record);
                                  analytics.track(
                                    'Double Clicked Encounter From List View',
                                    {
                                      email: user?.email,
                                    }
                                  );
                                }
                              },
                            })}
                            rowClassName={(record, index) => {
                              let baseClass =
                                'border-none bg-transparent hover:bg-transparent';

                              if (
                                record?.encounter_id === selectedEncounterValue
                              ) {
                                baseClass =
                                  'selectedAura bg-[#ebecf0] transform transition duration-200 ease-in-out';
                              } else if (
                                index >= 0 &&
                                encounterList[index + 1]?.encounter_id ===
                                  selectedEncounter?.encounter_id
                              ) {
                                baseClass = 'selectedAuraTop';
                              }

                              if (
                                selectedRowKeys.includes(record?.encounter_id)
                              ) {
                                baseClass += ' row-selected';
                              }

                              return baseClass;
                            }}
                            showSorterTooltip={false}
                            dataSource={filteredEncounterList}
                            loading={{
                              indicator: <LoadingBar />,
                              spinning: isEncounterListLoading,
                            }}
                            locale={{
                              emptyText: 'No Data',
                            }}
                            tableLayout="auto"
                            sortDirections={['asc', 'desc', 'asc']}
                            sortedInfo={sortState}
                            storedParams={storedParams}
                            selectedRowKeys={selectedRowKeys}
                            setSelectedRowKeys={setSelectedRowKeys}
                            handleEncountersSorting={handleEncountersSorting}
                            settingsOrgValue={settingsOrgValue}
                            isUrgent={false}
                            title={
                              pinnedEncounterList.length > 0 ? (
                                <div className="font-sans font-medium text-sm flex items-center pb-1 pl-4 gap-2">
                                  <Activity color="#36AEEA" />
                                  All Encounters
                                </div>
                              ) : (
                                <></>
                              )
                            }
                          />
                        </div>

                        <div className="bg-white flex flex-0 items-center justify-center">
                          {encounterList.length > 0 && (
                            <Pagination
                              align="center"
                              current={pageState.current}
                              pageSize={pageState.pageSize}
                              total={encounterListCount}
                              onChange={(page, pageSize) => {
                                dispatch(selectedEncounterSlice(null));
                                setPageState({
                                  current: page,
                                  pageSize,
                                });
                              }}
                              disabled={isEncounterListLoading}
                              className="custom-pagination-class "
                              showSizeChanger={false}
                              pageSizeOptions={['10', '30', '50', '100']}
                              size="small"
                              locale={{ items_per_page: '' }}
                            />
                          )}
                        </div>
                        {retryDemoJsx}
                      </div>
                    </Resizable>
                  )
                ) : (
                  <Resizable
                    className="shadow-xl bg-white ant-table-wrappers rounded-xl relative"
                    defaultSize={{ width: '49%' }}
                    minWidth={'40%'}
                    maxWidth={'55%'}
                    enable={{
                      top: false,
                      right: true,
                      bottom: false,
                      left: false,
                      topRight: false,
                      bottomRight: false,
                      bottomLeft: false,
                      topLeft: false,
                    }}
                    handleComponent={{
                      right: (
                        <div className="absolute top-1/2 right-0 mr-3">
                          <DragIcon />
                        </div>
                      ),
                    }}
                  >
                    <AuraFullCalendar
                      className={'appointment-page-table'}
                      dataSource={encounterList}
                      selectedEncounterSlice={selectedEncounterSlice}
                      setEncounterStatus={setEncounterStatus}
                      setPageState={setPageState}
                      setStartDate={setStartDate}
                      setEndDate={setEndDate}
                      setIsCustomSelected={setIsCustomSelected}
                      setSelectedDate={setSelectedDate}
                      auraView={auraView}
                      startDate={startDate}
                      endDate={endDate}
                      setRecord={setRecord}
                      changeEncounterStatus={changeEncounterStatus}
                      handleCalendarEventClick={handleCalendarEventClick}
                      handleCalendarEventDateChange={
                        handleCalendarEventDateChange
                      }
                    ></AuraFullCalendar>
                  </Resizable>
                )}

                {(encounterList.length > 0 || pinnedEncounterList.length > 0) &&
                  encounterPhase !== 'vca-summary' && (
                    <div
                      className={`flex flex-col overflow-hidden relative flex-1 ${
                        isRowDoubleClicked ? 'w-3/4' : 'w-1/2'
                      } current bg-white shadow-xl rounded-xl relative`}
                    >
                      {restrictNoteAccess && (
                        <div className="absolute inset-0 bg-gray-200/80 z-50 backdrop-blur-[5px]">
                          <div className="flex items-center justify-center h-full">
                            <div className="text-center text-gray-800">
                              <div className="text-2xl font-bold mb-2 flex items-center gap-2">
                                <LockOutlined />
                                Access Restricted
                              </div>
                              <div className="text-gray-600">
                                You do not have access to this note.
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="flex-0">
                        {showSegmentedTabs && (
                          <div
                            className={`p-2 ${
                              encounterStatus === 'completed' ||
                              showSegmentedTabs
                                ? 'border-b border-gray-200'
                                : ''
                            } flex justify-between`}
                          >
                            <SegmentedTabs
                              options={recordingTabs}
                              activeTab={activeButton}
                              setActiveTab={setActiveButton}
                              disabled={isSegmentDisabled}
                            />
                          </div>
                        )}
                        {schedulepage ? null : getEncounterDetails(record)}
                        <div className=" flex gap-2 items-center justify-between ">
                          <LanguageSelector />
                          {encounterStatus === 'completed' &&
                            encounterPhase === 'after-visit' && (
                              <Dropdown
                                overlay={
                                  <ul className="bg-white shadow-md rounded-md py-1 min-w-[140px]">
                                    <li
                                      className={`px-3 py-2 flex items-center ${
                                        templateCount < 2
                                          ? 'opacity-50 cursor-not-allowed'
                                          : 'hover:bg-gray-100 cursor-pointer'
                                      }`}
                                      onClick={(e) => {
                                        if (templateCount < 2) {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          return;
                                        }
                                        setManageDropdownVisible(false);
                                        handleOpenDrawer();
                                      }}
                                      style={{
                                        pointerEvents:
                                          templateCount < 2 ? 'none' : 'auto',
                                      }}
                                    >
                                      <SwapOutlined className="mr-2" />
                                      Select Another
                                    </li>
                                    <li
                                      className="px-3 py-2 hover:bg-gray-100 cursor-pointer flex items-center "
                                      onClick={() => {
                                        setManageDropdownVisible(false);
                                        setDrawerOpen(true);
                                        setTemplatePopupOpen(true);
                                      }}
                                    >
                                      <FileAddOutlined className="mr-2" />
                                      Generate New
                                    </li>
                                  </ul>
                                }
                                trigger={['hover']}
                                placement="bottomRight"
                                open={manageDocumentDropdownVisible}
                                onOpenChange={setManageDropdownVisible}
                              >
                                <a
                                  className="flex items-center underline decoration-dotted justify-center rounded-full cursor-pointer text-xs text-gray-500  mt-2 mr-2"
                                  onMouseEnter={() =>
                                    setManageDropdownVisible(true)
                                  }
                                >
                                  <DiffOutlined className="mr-1 text-gray-800" />
                                  Manage Documents &gt;
                                </a>
                              </Dropdown>
                            )}
                        </div>

                        {encounterPhase !== 'pre-chart' && (
                          <>
                            <div
                              ref={containerRef}
                              className="flex items-center justify-center mt-2 flex-wrap gap-2 empty:hidden"
                            >
                              {(encounterStatus === 'completed' ||
                                encounterStatus === 'summary_inprogress' ||
                                encounterPhase === 'dictate') && (
                                <>
                                  {encounterPhase == 'in-visit' && (
                                    <Button
                                      type={'button'}
                                      className="bg-[#00D090] hover:bg-[#059669] flex items-center justify-center text-white font-normal p-2 py-2 px-4 rounded-xl focus:outline-none focus:shadow-outline"
                                      onClick={handlePauseResumeToggle}
                                      disabled={!isStartEncounterAllowed}
                                    >
                                      {isRecording ? (
                                        <>
                                          <span className="mr-2 mt-0">
                                            <ResumeIcon />
                                          </span>
                                          Resuming ...
                                        </>
                                      ) : !buttonSmall && !isSmallScreen ? (
                                        <div className="flex items-center cursor-pointer gap-1 text-white text-xs">
                                          <ResumeIcon height="14" width="14" />
                                          Resume
                                        </div>
                                      ) : (
                                        <Tooltip
                                          title="Resume"
                                          placement="bottom"
                                        >
                                          <div className="flex items-center cursor-pointer py-[1px] text-xs gap-1">
                                            <ResumeIcon
                                              height="15"
                                              width="15"
                                            />
                                          </div>
                                        </Tooltip>
                                      )}
                                    </Button>
                                  )}
                                  {encounterPhase === 'dictate' ? (
                                    <Button
                                      type={'button'}
                                      className="bg-[#00D090] hover:bg-[#059669] flex items-center justify-center text-white font-normal rounded-xl focus:outline-none focus:shadow-outline"
                                      onClick={handleMedicalNotesCopy}
                                    >
                                      {!isSmallScreen ? (
                                        <div className="flex items-center cursor-pointer gap-1 text-white text-xs">
                                          <CopiesIcon height="15" width="15" />
                                          Copy all
                                        </div>
                                      ) : (
                                        <Tooltip
                                          title="Copy all"
                                          placement="bottom"
                                        >
                                          <div className="flex items-center cursor-pointer py-[1px] text-xs gap-1">
                                            <CopiesIcon
                                              height="15"
                                              width="15"
                                            />
                                          </div>
                                        </Tooltip>
                                      )}
                                    </Button>
                                  ) : (
                                    <Dropdown.Button
                                      type="primary"
                                      onClick={handleMedicalNotesCopy}
                                      trigger={['hover']}
                                      icon={<ExpandIcon fill={'#ffffff'} />}
                                      style={{ width: '50%' }}
                                      rootClassName="copy-all drop-shadow-sm flex"
                                      overlay={MedicalCopyOptions()}
                                    >
                                      {!isSmallScreen ? (
                                        <div className="flex items-center cursor-pointer gap-1 text-white text-xs">
                                          <CopiesIcon height="15" width="15" />
                                          Copy all
                                        </div>
                                      ) : (
                                        <Tooltip
                                          title="Copy all"
                                          placement="bottom"
                                        >
                                          <div className="flex items-center cursor-pointer py-[1px] text-xs gap-1  ">
                                            <CopiesIcon
                                              height="15"
                                              width="15"
                                            />
                                          </div>
                                        </Tooltip>
                                      )}
                                    </Dropdown.Button>
                                  )}
                                  {encounterPhase !== 'dictate' &&
                                    encounterPhase !== 'vca-summary' && (
                                      <EncounterSummaryMagicEdit
                                        editableSummaryRef={editableSummaryRef}
                                        isMagicEditingRef={isMagicEditingRef}
                                        searchFilters={storedParams}
                                        encounter_id={
                                          record?.encounter_id
                                            ? record?.encounter_id
                                            : selectedEncounter?.encounter_id
                                        }
                                        schedulepage={schedulepage}
                                        encounterDetails={record}
                                        encounterPhase={encounterPhase}
                                        restrictTemplates={restrictTemplates}
                                        suggestions={suggestions}
                                        patientDetails={patientDetails}
                                        ref={inVisitRef}
                                        settingsOrgValue={settingsOrgValue}
                                      />
                                    )}
                                  {encounterPhase === 'after-visit' &&
                                    encounterStatus === 'completed' && (
                                      <TemplateTableWrapper
                                        record={record}
                                        encounterPhase={encounterPhase}
                                        restrictTemplates={restrictTemplates}
                                        selectedRecord={record}
                                        setEncounterStatus={setEncounterStatus}
                                        schedulepage={schedulepage}
                                        searchFilters={searchFilters}
                                        drawerOpen={drawerOpen}
                                        setDrawerOpen={setDrawerOpen}
                                        templatePopupOpen={templatePopupOpen}
                                        setTemplatePopupOpen={
                                          setTemplatePopupOpen
                                        }
                                        handleCloseDrawer={handleCloseDrawer}
                                        setTemplateCount={setTemplateCount}
                                      />
                                    )}
                                  {encounterPhase !== 'dictate' &&
                                    encounterPhase !== 'vca-summary' && (
                                      <div className="flex justify-end">
                                        <div>
                                          <Dropdown.Button
                                            type="primary"
                                            onClick={() =>
                                              handleRegenerate('update')
                                            }
                                            trigger={['hover']}
                                            icon={
                                              <ExpandIcon fill={'#ffffff'} />
                                            }
                                            style={{ width: '50%' }}
                                            rootClassName="rounded-xl drop-shadow-sm flex bg-[#00D090] hover:bg-[#059669] text-xs"
                                            disabled={
                                              !isSummaryGenerationAllowed
                                            }
                                            overlay={
                                              <Menu>
                                                <Menu.Item
                                                  key="1"
                                                  onClick={() =>
                                                    handleRegenerate(
                                                      'overwrite'
                                                    )
                                                  }
                                                >
                                                  <div className="flex items-center cursor-pointer gap-1 text-black font-normal">
                                                    <AmbientloadIcon
                                                      height="15"
                                                      width="15"
                                                    />
                                                    Regenerate from scratch
                                                  </div>
                                                </Menu.Item>
                                              </Menu>
                                            }
                                            className={'h-[35px]'}
                                            id="regenicon"
                                          >
                                            <div className="flex items-center cursor-pointer text-xs">
                                              <Tooltip
                                                title="Regenerate"
                                                placement="bottom"
                                              >
                                                <div className="flex items-center gap-2">
                                                  {isSummaryRegenerationLoading ? (
                                                    <RegenIcon
                                                      height="15"
                                                      width="15"
                                                    />
                                                  ) : (
                                                    <AmbientloadIcon />
                                                  )}
                                                  {!isSmallScreen && (
                                                    <div className="flex items-center cursor-pointer text-xs text-white">
                                                      Regenerate
                                                    </div>
                                                  )}
                                                </div>
                                              </Tooltip>
                                            </div>
                                          </Dropdown.Button>
                                        </div>

                                        <div className="download">
                                          {encounterPhase === 'after-visit' &&
                                            encounterStatus === 'completed' && (
                                              <div className="flex justify-end mr-1 ml-3">
                                                <Tooltip
                                                  title="Download PDF"
                                                  placement="bottom"
                                                >
                                                  <div>
                                                    <Button
                                                      trigger={['hover']}
                                                      type={'button'}
                                                      onClick={handleExportPDF}
                                                      loading={
                                                        summaryExportLoading
                                                      }
                                                      disabled={
                                                        isSaving ||
                                                        isSummaryOutdated
                                                      }
                                                      className={
                                                        'h-[35px] bg-[#E77A7A] hover:bg-[#991b1b]'
                                                      }
                                                    >
                                                      <span>
                                                        <div className="flex items-center cursor-pointer gap-2 ">
                                                          {isSmallScreen ? (
                                                            <div className="flex items-center cursor-pointer text-xs gap-2">
                                                              <PdfIcon />
                                                            </div>
                                                          ) : (
                                                            <div className="flex items-center cursor-pointer text-xs gap-2 ">
                                                              <PdfIcon />
                                                              Download PDF
                                                            </div>
                                                          )}
                                                        </div>
                                                      </span>
                                                    </Button>
                                                  </div>
                                                </Tooltip>
                                              </div>
                                            )}
                                        </div>
                                      </div>
                                    )}
                                  {isDictationEntitled ? (
                                    <div>
                                      <Tooltip
                                        placement="rightTop"
                                        title={
                                          <span style={{ fontSize: '12px' }}>
                                            {encounterPhase === 'dictate'
                                              ? 'Click here to start dictation'
                                              : 'Toggle with Ctrl + I'}
                                          </span>
                                        }
                                        open={isDictateTooltipOpen}
                                      >
                                        <div>
                                          {!dictationStarted ? (
                                            <Button
                                              type={'button'}
                                              onClick={handleDictation}
                                              className={'h-[35px]'}
                                              disabled={
                                                !canStartDictationEncounter
                                              }
                                            >
                                              <span>
                                                <div className="flex items-center cursor-pointer text-xs ">
                                                  <div className="flex items-center">
                                                    {waitingForSocketConnection ? (
                                                      <Spin
                                                        indicator={
                                                          <LoadingOutlined
                                                            height="15"
                                                            width="15"
                                                            style={{
                                                              color: '#ffffff',
                                                            }}
                                                            spin
                                                          />
                                                        }
                                                      />
                                                    ) : (
                                                      <div className="flex items-center gap-1">
                                                        <DictateMic
                                                          height="20"
                                                          width="20"
                                                        />
                                                        {!isSmallScreen && (
                                                          <div className="flex items-center cursor-pointer text-xs">
                                                            Dictate
                                                          </div>
                                                        )}
                                                        {!isOP && (
                                                          <ProIcon
                                                            height="20"
                                                            width="20"
                                                          />
                                                        )}
                                                      </div>
                                                    )}
                                                  </div>
                                                </div>
                                              </span>
                                            </Button>
                                          ) : (
                                            <Button
                                              type={'button'}
                                              onClick={() => {
                                                if (
                                                  encounterPhase === 'dictate'
                                                ) {
                                                  analytics.track(
                                                    'Clicked Stop Dictation From Solo Dictation',
                                                    { email: user?.email }
                                                  );
                                                }
                                                endStream();
                                                setDictationStarted(false);
                                                setwaitingForSocketConnection(
                                                  false
                                                );
                                                medicalConversationBoxRef.current?.stopDictation();
                                              }}
                                              className={
                                                'h-[35px] bg-[#d1112f] hover:bg-[#991b1b]'
                                              }
                                            >
                                              <span>
                                                <div className="flex items-center cursor-pointer text-xs ">
                                                  <div className="flex items-center cursor-pointer">
                                                    <DictateStopIcon
                                                      height="15"
                                                      width="15"
                                                    />
                                                    Stop
                                                  </div>
                                                </div>
                                              </span>
                                            </Button>
                                          )}
                                        </div>
                                      </Tooltip>
                                    </div>
                                  ) : (
                                    <>
                                      <UpgradeTooltip>
                                        <Button
                                          type={'button'}
                                          disabled={true}
                                          className={
                                            'h-[35px] bg-gray-400 hover:bg-gray-500 cursor-not-allowed'
                                          }
                                        >
                                          <span>
                                            <div className="flex items-center text-xs ">
                                              <div className="flex items-center">
                                                <>
                                                  <DictateMic
                                                    height="15"
                                                    width="15"
                                                  />
                                                  <div className="flex items-center text-xs mr-2">
                                                    Dictate
                                                  </div>
                                                  <LockIcon
                                                    height="15"
                                                    width="15"
                                                  />
                                                </>
                                              </div>
                                            </div>
                                          </span>
                                        </Button>
                                      </UpgradeTooltip>
                                    </>
                                  )}
                                  {ehrSettings?.ehr_system &&
                                    (record?.encounter_ehr_data ||
                                      ehrSettings?.ehr_system === 'instride') &&
                                    encounterPhase !== 'dictate' &&
                                    encounterPhase !== 'vca-summary' &&
                                    (ehrSettings?.ehr_system !==
                                      'office_practicum' ||
                                      isOPPushEhrEnabled) && (
                                      <>
                                        <Tooltip
                                          title={getEhrSubmissionTooltip()}
                                          color={
                                            isOPEhrSuccess
                                              ? '#ffffff'
                                              : undefined
                                          }
                                          overlayStyle={
                                            isOPEhrSuccess
                                              ? { maxWidth: 'none' }
                                              : undefined
                                          }
                                          overlayInnerStyle={
                                            isOPEhrSuccess
                                              ? {
                                                  background: '#ffffff',
                                                  color: '#1F2937',
                                                  padding: 8,
                                                  borderRadius: 12,
                                                  boxShadow:
                                                    '0 10px 30px rgba(16, 24, 40, 0.12)',
                                                  maxWidth: 'none',
                                                  width: 336,
                                                }
                                              : undefined
                                          }
                                          open={
                                            isOPSaveDisabled ||
                                            isEhrSaveDelayed ||
                                            isOpEhrSyncDisabled
                                              ? undefined
                                              : ehrSubmissionTooltip.open
                                          }
                                          onOpenChange={(open) => {
                                            if (
                                              isOPSaveDisabled ||
                                              isEhrSaveDelayed ||
                                              isOpEhrSyncDisabled
                                            )
                                              return;
                                            setEhrSubmissionTooltip((prev) => ({
                                              ...prev,
                                              open: open,
                                              message:
                                                !open && prev.status === 'idle'
                                                  ? ''
                                                  : prev.message,
                                              status:
                                                !open && prev.status === 'idle'
                                                  ? 'idle'
                                                  : prev.status,
                                            }));
                                          }}
                                        >
                                          <div
                                            onClickCapture={() => {
                                              if (isOPEhrSuccess) {
                                                setEhrSubmissionTooltip({
                                                  open: false,
                                                  message: '',
                                                  status: 'idle',
                                                });
                                              }
                                            }}
                                          >
                                            <EHRSubmissionDropdown
                                              onSaveToEHR={handleSubmitToEHR}
                                              isSubmitting={isSubmitting}
                                              record={record}
                                              ehrSubmissionTooltip={
                                                ehrSubmissionTooltip
                                              }
                                              practitionerSettings={
                                                currentPractitionerSettings
                                              }
                                              currentTemplate={getCurrentTemplate()}
                                              isSmallScreen={isSmallScreen}
                                              encounterPhase={encounterPhase}
                                              disabled={
                                                isOPSaveDisabled ||
                                                isEhrSaveDelayed ||
                                                isOpEhrSyncDisabled
                                              }
                                              saveDelayCountdown={
                                                isEhrSaveDelayed
                                                  ? ehrSaveCountdown
                                                  : null
                                              }
                                            />
                                          </div>
                                        </Tooltip>
                                        <EHRResponseModal
                                          isVisible={isEHRResponseModalVisible}
                                          onConfirm={handleModalOk}
                                          onCancel={handleModalCancel}
                                          response={ehrSubmitDocumentMessage}
                                        />
                                      </>
                                    )}
                                </>
                              )}
                              {encounterStatus === 'completed' &&
                                activeButton === 'Transcription' && (
                                  <div className="flex">
                                    <Dropdown.Button
                                      type="primary"
                                      onClick={handleTranscriptionCopy}
                                      icon={<ExpandIcon fill={'#ffffff'} />}
                                      placement="bottomLeft"
                                      overlay={TranscriptCopyOptions}
                                      rootClassName="copy-all rounded-xl drop-shadow-sm flex bg-[#00D090] hover:bg-[#059669] ml-3"
                                    >
                                      <div className="flex items-center cursor-pointer gap-1 text-white font-normal ml-5">
                                        <CopiesIcon height="15" width="15" />
                                        Copy all
                                      </div>
                                    </Dropdown.Button>
                                  </div>
                                )}
                              {encounterStatus === 'completed' &&
                                encounterPhase !== 'dictate' &&
                                encounterPhase !== 'vca-summary' && (
                                  <Popover
                                    content={
                                      <div
                                        onMouseEnter={() =>
                                          handleShowUpgradeTooltip('select')
                                        }
                                        onMouseLeave={handleHideUpgradeTooltip}
                                        style={{ zIndex: '99999999999999999' }}
                                      >
                                        <UpgradeButton
                                          text="Upgrade to access this feature"
                                          analyticsEvent="Clicked Add Organization Logo"
                                        />
                                      </div>
                                    }
                                    open={
                                      !isAuraPro && activePopover === 'select'
                                    }
                                    trigger="hover"
                                    placement="rightTop"
                                    mouseLeaveDelay={0.3}
                                    overlayInnerStyle={{ padding: '0px' }}
                                    align={{
                                      offset: [100, 50],
                                    }}
                                    zIndex={9999999999999}
                                    onOpenChange={(visible) => {
                                      if (!visible) {
                                        handleHideUpgradeTooltip();
                                      }
                                    }}
                                  >
                                    <Dropdown
                                      overlay={
                                        <ul className="bg-white shadow-md rounded-md py-1 min-w-[140px]">
                                          <li
                                            className="px-3 py-2 hover:bg-gray-100 cursor-pointer flex items-center"
                                            onClick={
                                              !isAuraPro
                                                ? () =>
                                                    handleShowUpgradeTooltip(
                                                      'select'
                                                    )
                                                : handleLogoChangeClick
                                            }
                                          >
                                            <PictureOutlined className="mr-2" />
                                            Add organization logo
                                          </li>
                                          <li
                                            className="px-3 py-2 flex items-center text-gray-400 cursor-not-allowed opacity-50"
                                            onClick={() => {
                                              setSettingsDropdownVisible(false);
                                              handleHideUpgradeTooltip();
                                              // setIsSendEmailDrawerOpen(true);
                                            }}
                                          >
                                            <MailOutlined className="mr-2" />
                                            Send as email
                                          </li>
                                        </ul>
                                      }
                                      trigger={['click']}
                                      placement="bottomLeft"
                                      open={settingsDropdownVisible}
                                      onOpenChange={(value) => {
                                        setSettingsDropdownVisible(value);
                                        handleHideUpgradeTooltip();
                                      }}
                                    >
                                      <Button
                                        type={'button'}
                                        className="flex items-center justify-center !p-2 rounded-xl focus:outline-none focus:shadow-outline border bg-white hover:bg-gray-100"
                                      >
                                        <EllipsisOutlined className="text-black" />
                                      </Button>
                                    </Dropdown>
                                  </Popover>
                                )}
                            </div>
                            <div className="flex justify-center mt-2 empty:hidden">
                              <SummaryUpdatedStatus
                                isSaving={isSaving}
                                isSummaryOutdated={isSummaryOutdated}
                                updatedTime={
                                  editableSummaryRef.current?.updated_at
                                }
                                encounterStatus={encounterStatus}
                                encounterPhase={encounterPhase}
                                lastSaved={editedSummary?.updated_at}
                                isRollingBack={isRollingBack}
                                onRollback={handleRollback}
                              />
                            </div>
                          </>
                        )}
                      </div>
                      <div className="h-full overflow-hidden flex flex-col">
                        {renderEncounterPanelContent()}
                        {showMicrophoneBar ? (
                          <div className="fixed bottom-[40px] right-[24px] z-[999] w-[240px] rounded-lg">
                            <MicrophoneBar
                              setActiveButton={setActiveButton}
                              encounterPhase={encounterPhase}
                              isStreaming={isChartStreaming || isVisitStreaming}
                              currentActive={currentActive}
                              isRecording={isChartRecording || isVisitRecording}
                              setIsRecording={
                                isChartRecording
                                  ? setIsChartRecording
                                  : setIsVisitRecording
                              }
                              setIsStreaming={
                                isChartStreaming
                                  ? setIsChartStreaming
                                  : setIsVisitStreaming
                              }
                              schedulepage={schedulepage}
                              setShowSaveDeleteButtons={
                                setShowSaveDeleteButtons
                              }
                              selectedRecord={record}
                              storedParams={storedParams}
                              setRecord={setRecord}
                              setEncounterStatus={setEncounterStatus}
                              setActiveRightPanelTab={setActiveRightPanelTab}
                            />
                          </div>
                        ) : null}
                      </div>
                    </div>
                  )}

                {encounterPhase === 'in-visit' &&
                  !restrictNoteAccess &&
                  (encounterList.length > 0 ||
                    pinnedEncounterList.length > 0) && (
                    <EncounterRightSidePanel
                      ref={icd10CodingRef}
                      activeTab={activeRightPanelTab}
                      initTranscript={initTranscript}
                      isTranscribing={isTranscribing}
                      setActiveTab={setActiveRightPanelTab}
                      fullTranscript={fullTranscript}
                      setFullTranscript={setFullTranscript}
                      liveTranscript={liveTranscript}
                      livePartialTranscript={livePartialTranscript}
                      setLivePartialTranscript={setLivePartialTranscript}
                      encounterPhase={encounterPhase}
                      encounterStatus={encounterStatus}
                      summaryEvidences={summaryEvidences}
                      resetSummaryEvidence={resetSummaryEvidence}
                      onEditTranscription={handleEditTranscription}
                      encounter={record}
                      storedParams={storedParams}
                    />
                  )}

                {logoDrawerVisible ? (
                  <LogoManagementDrawer
                    isOpen={logoDrawerVisible}
                    onClose={() => setLogoDrawerVisible(false)}
                  />
                ) : null}
              </div>
            </div>
          )}
        </div>
      )}

      {showMicrophoneBar && encounterPhase === 'vca-summary' && (
        <div className="fixed bottom-[40px] right-[24px] z-[999] w-[240px] rounded-lg">
          <MicrophoneBar
            setActiveButton={setActiveButton}
            encounterPhase={encounterPhase}
            isStreaming={isChartStreaming || isVisitStreaming}
            currentActive={currentActive}
            isRecording={isChartRecording || isVisitRecording}
            setIsRecording={
              isChartRecording ? setIsChartRecording : setIsVisitRecording
            }
            setIsStreaming={
              isChartStreaming ? setIsChartStreaming : setIsVisitStreaming
            }
            schedulepage={schedulepage}
            setShowSaveDeleteButtons={setShowSaveDeleteButtons}
            selectedRecord={record}
            storedParams={storedParams}
            setRecord={setRecord}
            setEncounterStatus={setEncounterStatus}
            setActiveRightPanelTab={setActiveRightPanelTab}
          />
        </div>
      )}

      <SendEmailDrawer
        isOpen={isSendEmailDrawerOpen}
        onClose={() => setIsSendEmailDrawerOpen(false)}
      />
    </div>
  );
};

export default EncounterDesktopView;
